export class Comment {
	Id: string;
	CreatedDate: string;
	ObjectId: string;
	ObjectType: string;
	CommenterId: string;
	CommentText: string;
	EditText: string;
	Commenter: {
		Id: string;
		Email: string;
		FullName: string;
		Active: boolean;
		Role: any;
	}
}
